import React from 'react'
import styles from './Scheme.module.scss'
import { motion } from "framer-motion"
import image_1 from '../../image/Scheme/image_1.svg'

export const Scheme = () => {

    const titleAnimation = {
        hidden: {
            y: 200,
            opacity: 0,
        },
    
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: .5 }
        }
    }
    
    const boxAnimation = {
        hidden: {
            y: 500,
            opacity: 0,
        },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: .9}
        } 
    }

    return (
        <motion.section 
            className={styles.main}
            id='Deadlines' 
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
        >
            <div className={styles.container}>
            <motion.h2 className={styles.title} variants={titleAnimation}><span>Как мы работаем</span> с&#160;клиентами?</motion.h2>
            <motion.ul className={styles.list} variants={boxAnimation}>
                <li className={styles.item}>
                    <div className={styles.item_container}>
                        <div className={styles.box} >
                            <div className={styles.item_box}>
                                <img className={styles.icon} src={image_1} alt='этап'/>
                                <p className={styles.number}>01</p>
                            </div>
                            <h3 className={styles.item_title}>Заявка</h3>
                            <p className={styles.item_text}>Вы оставляете электронную заявку на сайте, электронной почте, мессенджере или звоните нам по телефону.</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>
                <li className={styles.item}>
                    <div className={styles.item_container_red}>
                        <div className={styles.box_red} >
                            <div className={styles.item_box}>
                                <img className={styles.icon} src={image_1} alt='этап'/>
                                <p className={styles.number}>02</p>
                            </div>
                            <h3 className={styles.item_title}>Консультация</h3>
                            <p className={styles.item_text}>Наш менеджер связывается с вами и рассказывает о всех условиях работы, ориентирует по стоимости работ, согласует время и дату.</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>
                <li className={styles.item}>
                    <div className={styles.item_container}>
                        <div className={styles.box} >
                        <div className={styles.item_box}>
                            <img className={styles.icon} src={image_1} alt='этап'/>
                            <p className={styles.number}>03</p>
                        </div>
                        <h3 className={styles.item_title}>Монтаж</h3>
                        <p className={styles.item_text}>Приезд на объект в назначенный день и время. Выполнение работ по установке счетчиков и вспомогательного оборудования!</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>
                <li className={styles.item}>
                    <div className={styles.item_container_red}>
                        <div className={styles.box_red} >
                            <div className={styles.item_box}>
                                <img className={styles.icon} src={image_1} alt='этап'/>
                                <p className={styles.number}>04</p>
                            </div>
                            <h3 className={styles.item_title}>Пломбировка</h3>
                            <p className={styles.item_text}>Пломбировка приборов учета с последующей передачей информации в управляющую компанию!</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>
                <li className={styles.item}>
                    <div className={styles.item_container}>
                        <div className={styles.box} >
                            <div className={styles.item_box}>
                                <img className={styles.icon} src={image_1} alt='этап'/>
                                <p className={styles.number}>05</p>
                            </div>
                            <h3 className={styles.item_title}>Сдача объекта</h3>
                            <p className={styles.item_text}>Сдача объекта в соответствии с техническим заданием заказчика.</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>
                <li className={styles.item}>
                    <div className={styles.item_container_red}>
                        <div className={styles.box_red} >
                            <div className={styles.item_box}>
                                <img className={styles.icon} src={image_1} alt='этап'/>
                                <p className={styles.number}>06</p>
                            </div>
                            <h3 className={styles.item_title}>Оплата</h3>
                            <p className={styles.item_text}>Вы оплачиваете согласованную стоимость работ, мы предоставляем  на нее гарантию в течении года.</p>
                        </div>
                    </div>
                    <div className={styles.item_background}></div>
                </li>         
            </motion.ul>
            </div>   
        </motion.section>
        
        
    )
}
